import React from 'react';
import Avatar from '@mui/material/Avatar';

// The provider's logo (an SVG served by crm_service), on white in both themes.
export default function IntegrationLogo({ integration, size = 56 }) {
  return (
    <Avatar
      src={integration?.logo_url}
      alt={integration?.name}
      sx={{ width: size, height: size, bgcolor: 'common.white', border: 1, borderColor: 'divider' }}
      slotProps={{ img: { sx: { objectFit: 'contain' } } }}
    />
  );
}
